
import React from "react";
import { Users, User } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";

interface FollowStatsProps {
  followersCount: number;
  followingCount: number;
  loading: boolean;
  onViewFollowers?: () => void;
  onViewFollowing?: () => void;
}

const FollowStats = ({ 
  followersCount, 
  followingCount, 
  loading,
  onViewFollowers,
  onViewFollowing 
}: FollowStatsProps) => {
  return (
    <>
      <motion.div 
        className="bg-primary/5 rounded-lg p-4 text-center cursor-pointer"
        whileHover={{ y: -5, boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}
        transition={{ duration: 0.2 }}
        onClick={onViewFollowers}
      >
        <div className="flex flex-col items-center">
          <Users className="h-6 w-6 text-blue-500 mb-1" />
          <span className="text-sm font-medium">Followers</span>
          {loading ? (
            <div className="animate-pulse h-8 w-8 bg-muted rounded-full mx-auto"></div>
          ) : (
            <motion.span 
              className="text-2xl font-bold"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              {followersCount}
            </motion.span>
          )}
          {!loading && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="mt-2 text-xs"
              onClick={(e) => {
                e.stopPropagation();
                if (onViewFollowers) onViewFollowers();
              }}
            >
              View All
            </Button>
          )}
        </div>
      </motion.div>
      
      <motion.div 
        className="bg-primary/5 rounded-lg p-4 text-center cursor-pointer"
        whileHover={{ y: -5, boxShadow: "0 4px 8px rgba(0,0,0,0.1)" }}
        transition={{ duration: 0.2 }}
        onClick={onViewFollowing}
      >
        <div className="flex flex-col items-center">
          <User className="h-6 w-6 text-green-500 mb-1" />
          <span className="text-sm font-medium">Following</span>
          {loading ? (
            <div className="animate-pulse h-8 w-8 bg-muted rounded-full mx-auto"></div>
          ) : (
            <motion.span 
              className="text-2xl font-bold"
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: "spring", stiffness: 100 }}
            >
              {followingCount}
            </motion.span>
          )}
          {!loading && (
            <Button 
              variant="ghost" 
              size="sm" 
              className="mt-2 text-xs"
              onClick={(e) => {
                e.stopPropagation();
                if (onViewFollowing) onViewFollowing();
              }}
            >
              View All
            </Button>
          )}
        </div>
      </motion.div>
    </>
  );
};

export default FollowStats;
